/**
 * orga-app-api - pandemie-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Landkreis { 
    landkreis_id?: string;
    bezeichnung?: string;
    typ?: string;
    anzeige?: string;
    bundesland?: string;
}

